/**
 * (main) layout — bottom tab bar for the 4 main routes.
 *
 * Phase 3.5: replaces the static visual tab bar that lived inside
 * `home.tsx` since 3.1. The (main) route group is a sibling of
 * (onboarding) — they don't share layouts.
 *
 * Tabs:
 *  - /home    → Beranda (the home card stack from Phase 3.1-3.4)
 *  - /library → Riwayat (Phase 4 — worksheet archive)
 *  - /belanja  → Belanja (coming soon)
 *  - /akun    → Akun    (Phase 5 — parent zone)
 *
 * Per plan §10 + 03.5: Tabs adalah ikon + label, native expo-router
 * Tabs, active = brand purple. Ikon clay generated (Fase 3 — sebelumnya
 * emoji). Native iOS/Android tabs are rendered automatically when
 * expo-router sees <Tabs>.
 */

import { Tabs } from 'expo-router';
import { StyleSheet, View } from 'react-native';

import { AppIcon } from '@/components/app-icon';
import { Brand, Colors, Spacing } from '@/constants/theme';
import { MISC_ICON, temaIcon } from '@/lib/icons';

export default function MainTabsLayout() {
  return (
    <Tabs
      screenOptions={{
        headerShown: false,
        tabBarActiveTintColor: Brand.primary,
        tabBarInactiveTintColor: '#6b6573',
        tabBarStyle: styles.tabBar,
        tabBarLabelStyle: styles.tabLabel,
        tabBarItemStyle: styles.tabItem,
      }}
    >
      <Tabs.Screen
        name="home"
        options={{
          title: 'Beranda',
          tabBarIcon: () => <TabIcon source={temaIcon('Kebutuhanku')} />,
        }}
      />
      <Tabs.Screen
        name="library"
        options={{
          title: 'Aktivitas',
          tabBarIcon: () => <TabIcon source={MISC_ICON.books} />,
        }}
      />
      <Tabs.Screen
        name="belanja"
        options={{
          title: 'Belanja',
          popToTopOnBlur: true,
          tabBarIcon: () => <TabIcon source={MISC_ICON.shoppingBag} />,
        }}
      />
      <Tabs.Screen
        name="akun"
        options={{
          title: 'Akun',
          tabBarIcon: () => <TabAccountIcon />,
        }}
      />
    </Tabs>
  );
}

function TabIcon({ source }: { source: Parameters<typeof AppIcon>[0]['source'] }) {
  return (
    <View style={styles.iconWrap}>
      <AppIcon source={source} size={24} />
    </View>
  );
}

function TabAccountIcon() {
  return <TabIcon source={MISC_ICON.star} />;
}

const styles = StyleSheet.create({
  tabBar: {
    borderTopWidth: 1,
    borderTopColor: '#E5E5E5',
    backgroundColor: Colors.light.background,
    paddingTop: Spacing.one,
    paddingBottom: Spacing.two,
    height: 72,
  },
  tabItem: {
    paddingTop: 4,
  },
  tabLabel: {
    fontSize: 11,
    fontWeight: '500',
    marginTop: 2,
  },
  iconWrap: {
    alignItems: 'center',
    justifyContent: 'center',
  },
});
